module.exports = __webpack_public_path__ + "img/feedback-error.f166ace0.png";